import React from 'react';
import { ActivityIndicator } from '../../../components/common/activity-indicator/activity-indicator';
import { PageNotFoundView } from '../../../views';
import { RecallsProps } from '../recalls/hook/use-recalls-content';

interface Props {
    recallsContent: RecallsProps | null | undefined;
}

export const RecallsDetailsLoaderAndPageNotFound = (props: Props) => {
    return (
        <>
            {props.recallsContent &&
            props.recallsContent?.recallsDescription === 'loading' ? (
                <ActivityIndicator />
            ) : (
                <PageNotFoundView />
            )}
        </>
    );
};
